import styled from 'styled-components';
import { marginStyle } from '../../const/helpers';
import { IconProps } from './types';
import { displayHelperStyle } from '../../const/display';

const IconNonFilledStyled = styled.span<IconProps>`
  width: ${({ $size }) => `${$size}px`};
  height: ${({ $size }) => `${$size}px`};
  align-items: center;
  ${({ $display }) => $display && displayHelperStyle($display)};
  margin: ${({ $m }) => ($m ? `${$m.map(m => marginStyle(m)).join(' ')} !important` : '0')};
`;

export default IconNonFilledStyled;
